import { OtlFormSubmission } from "../../OtlForm/OtlFormSubmission";
import { sendGet } from "../networking/api";

export interface OtlSettings {
  enabled: boolean;
  startDate: string;
  endDate: string;
  period: string;
  voucherDate: string;
}

export async function getOtlSettings() {
  return await sendGet<OtlSettings>("/api/otl/settings");
}

export interface OtlReceipt {
  success: true;
  reference: string;
}
export class OtlSubmissionError extends Error {
  constructor(
    message: string,
    public status: number,
    public errors: Record<string, string[]> = {},
  ) {
    super(message);
  }
}
export async function submitOTL(
  otl: OtlFormSubmission & { submissionKey: string },
): Promise<OtlReceipt> {
  const response = await fetch("/api/otl/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(otl),
  });
  const result = await response.json();
  if (!response.ok) {
    const errors =
      result?.errors &&
      typeof result.errors === "object" &&
      !Array.isArray(result.errors)
        ? Object.fromEntries(
            Object.entries(result.errors).filter(
              (entry): entry is [string, string[]] =>
                Array.isArray(entry[1]) &&
                entry[1].every((message) => typeof message === "string"),
            ),
          )
        : {};
    throw new OtlSubmissionError(
      typeof result?.message === "string"
        ? result.message
        : "Unable to confirm receipt",
      response.status,
      errors,
    );
  }
  if (
    result?.success !== true ||
    typeof result.reference !== "string" ||
    !result.reference.trim()
  )
    throw new Error("Missing application receipt");
  return result;
}
